export const ChatCategory = {
    SUPPORT: 'Support',
    OTHER: 'Other',
    CLIENT_TICKETS: 'Client tickets',
    EXTERNAL_CHAT: 'External chat',
}